import axios from 'axios';
import { defineStore } from 'pinia';
import { api } from 'services/api';
import useLogger from 'composables/logger';
import Profile from '@models/Profile';

export const useAuthStore = defineStore({
  id: 'auth',
  state: () => ({
    profile: null as Profile | null,
  }),
  getters: {
    authenticated(state) {
      return Boolean(state.profile);
    },
    canImpersonate(): boolean {
      return this.isT2 || this.isT3;
    },
    canShipOrders(): boolean {
      return this.isT2 || this.isT3;
    },
    canUpdateAccount(): boolean {
      return this.isT2 || this.isT3;
    },
    canUpdateDevices(): boolean {
      return this.isT3;
    },
    isT2(state) {
      return state.profile?.groups?.includes('T2') === true;
    },
    isT3(state) {
      return state.profile?.groups?.includes('T3') === true;
    },
  },
  actions: {
    async getProfile() {
      let { profile } = this;
      if (profile) {
        return profile;
      }

      try {
        const response = await api.get<Profile>('/auth/profile', {
          baseURL: '/',
        });

        profile = response.data;
        this.profile = profile;
      } catch (error) {
        const logger = useLogger();

        if (!axios.isAxiosError(error) || error.response?.status !== 403) {
          logger.error('Failed to retrieve profile', <Error>error);
        }
      }

      return profile;
    },
  },
});
